import React, {Component} from 'react';
import './PhoneDetail.css';

export default class PhoneDetail extends Component {
    newFeaturedTag = (x) => {
        return(x==="" ? <div></div> : <div className="text-center newTag">{x}</div>)
    }

    hotpickTag = (x) => {
        return(x==="" ? <div></div> : <div className="text-center hotpickTag">{x}</div>)
    }

    renderGenerationLabel = (x, y, fiveGLabel) => {
        if(y.trim() === ""){
            return(<div></div>)
        }
        else{
            if(y === "5G"){
                return(<div className={x} style={{backgroundImage: "url(" + encodeURI(fiveGLabel) + ")"}}>&nbsp;</div>)
            }
            else{
                return(<div className={x}>{y}</div>)
            }
        }

    }

    renderPlan = (x, y, z, a, link) => {
        let lang = window.THREE_REACT_APP_GLOBAL.language;
        let fontClass = " price-highlight" + (lang==="en" ? "EN" : "TC");

        let finalPrice = "$" + x.replace(/$/g, "");

        return(
            <a href={link} target={"_blank"}>
                <div className="plan-price col-xs-12">
                    {y} <div className="plan-price-hightlight"><div className={"price-hightlight" + fontClass}>{finalPrice}</div> {z}</div>
                    <div className="subtext">{a}</div>
                    <div className="right-arrow"> > </div>
                </div>
            </a>
        );
    }

    renderRetailPrice = (x, y, z, a, link) => {
        let lang = window.THREE_REACT_APP_GLOBAL.language;
        let fontClass = " retail-price-hightlight" + (lang==="en" ? "EN" : "TC");

        let finalPrice = "$" + x.replace(/$/g, "");

        return(
            <a href={link} target={"_blank"}>
                <div className="retail-price col-xs-12">
                    {y} <div className={"retail-price-hightlight" + fontClass}>{finalPrice}</div> {z}
                    <div className="retail-price-remark">{a==="" ? "" : a}</div>
                    <div className="right-arrow"> > </div>
                </div>
            </a>
        );
    }

    navigateToPhoneDetail = (l) => {
        window.location.href = l;
    }

    render(){
        let phoneObj = this.props.phoneObj;
        let index = this.props.index;
        let allNotRetail = this.props.allNotRetail;
        let fiveGLabel = this.props.fiveGLabel;

        let lang = window.THREE_REACT_APP_GLOBAL.language;

        let priceFragment = <React.Fragment></React.Fragment>;

        let rawPlanPrice = phoneObj.sPlanPrice.trim();
        let rawRPrice = phoneObj.rPrice.trim();

        if(rawPlanPrice!=="" && rawRPrice!==""){
            priceFragment = (
                <React.Fragment>
                    {this.renderPlan(phoneObj.sPlanPrice, phoneObj.sPlanLabel, phoneObj.sPlanUp, phoneObj.enjoyInfo, phoneObj.subscriptionLink)}
                    <div className="or_line col-xs-12">
                        <div className="col-xs-5 horizontal-line"></div>
                        <div className='col-xs-2 or-text'>{phoneObj.orTag}</div>
                        <div className="col-xs-5 horizontal-line"></div>
                    </div>
                    {this.renderRetailPrice(phoneObj.rPrice, phoneObj.rPriceLabel, phoneObj.rPriceUp, phoneObj.exclusiveLabel, phoneObj.retailLink)}
                </React.Fragment>
            );
        }
        else if(rawPlanPrice!=="" && rawRPrice===""){
            priceFragment = (
                <React.Fragment>
                    {this.renderPlan(phoneObj.sPlanPrice, phoneObj.sPlanLabel, phoneObj.sPlanUp, phoneObj.enjoyInfo, phoneObj.subscriptionLink)}
                </React.Fragment>
            );
        }
        else if(rawPlanPrice==="" && rawRPrice!==""){
            priceFragment = (
                <React.Fragment>
                    {this.renderRetailPrice(phoneObj.rPrice, phoneObj.rPriceLabel, phoneObj.rPriceUp, phoneObj.exclusiveLabel, phoneObj.retailLink)}
                </React.Fragment>
            );
        }

        let innerPhoneClassName = (lang === "en" ? " innerPhoneItemEng" : " innerPhoneItemChi");
        if(allNotRetail){
            innerPhoneClassName = innerPhoneClassName.replace("innerPhoneItem", "innerPhoneItemNotRetail");
        }

        let preMargin = (
            <React.Fragment>
                <div className="text-center blankTag"></div>
            </React.Fragment>
        );

        if(phoneObj.isNew.trim() !== "" && phoneObj.isHotPick.trim() !== "" && phoneObj.cellularGen.trim() !== ""){
            preMargin = (
                <React.Fragment>
                </React.Fragment>
            );
        }

        return(
            <div className={phoneObj.className} style={phoneObj.style} key={index}>
                <div className={"innerPhoneItem" + innerPhoneClassName}>
                    <a href={phoneObj.routingLink} target={"_blank"}>
                        <div className="withBg" style={phoneObj.bgStyle}>
                            {preMargin}
                            {this.newFeaturedTag(phoneObj.isNew)}
                            {this.hotpickTag(phoneObj.isHotPick)}
                            {this.renderGenerationLabel(phoneObj.geneClass, phoneObj.cellularGen, fiveGLabel)}
                        </div>
                        <div className={"mobile-name col-xs-12 " + (lang === "en" ? "mobileNameEN" : "mobileNameTC")}>{phoneObj.brand+" "+phoneObj.name}</div>
                    </a>
                    {/*{this.renderPlan(phoneObj.sPlanPrice, phoneObj.sPlanLabel, phoneObj.sPlanUp, phoneObj.enjoyInfo)}*/}
                    {/*<div className="or_line col-xs-12">*/}
                    {/*    <div className="col-xs-5 horizontal-line"></div> */}
                    {/*    <div className='col-xs-2 or-text'>{phoneObj.orTag}</div>*/}
                    {/*    <div className="col-xs-5 horizontal-line"></div>*/}
                    {/*</div>*/}
                    {/*{this.renderRetailPrice(phoneObj.rPrice, phoneObj.rPriceLabel, phoneObj.rPriceUp, phoneObj.exclusiveLabel)}*/}
                    {priceFragment}
                </div>
            </div>
        )
    }
}